import React, { useEffect, useState } from "react";
import Filters from "./Filters";
import { fieldKeys, getList, reassignDefaultPayload } from "./helper";
import DataTable from "./DataTable";
import { toast } from "react-toastify";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import { Col, Row } from "react-bootstrap";
import FieldSurveyRequest from "../fieldSurveyRequest";
import { submitBulkSurveyAction } from "../bulkSurvey/bulkApiHelper";
import { getFromDecreaptLocalStorage } from "../../utilFunctions";
import { VENDOR_MANAGER } from "../../consts";

const ListPage = ({ productNames }) => {
    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [notifyResurveyPayload, setNotifyResurveyPayload] = useState(null);
    const [selectedData, setSelectedData] = useState([])
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const vendorManagerDetails = getFromDecreaptLocalStorage("vendorManagerDetails");
    const isVendorManager = roleDataCookie?.roleName === VENDOR_MANAGER
    const defaultFieldValues = {
        [fieldKeys.season]: "",
        [fieldKeys.year]: "",
        [fieldKeys.product]: null,
        [fieldKeys.state]: "",
        [fieldKeys.district]: "",
        [fieldKeys.mandal]: "",
        [fieldKeys.village]: "",
        [fieldKeys.surveyStatus]: "",
        [fieldKeys.farmerId]: "",
        [fieldKeys.farmerName]: "",
        [fieldKeys.policyNumber]: "",
        [fieldKeys.surveyId]: "",
        [fieldKeys.surveyorName]: "",
        [fieldKeys.startDate]: "",
        [fieldKeys.endDate]: "",
        [fieldKeys.downloadStatus]: null,
        [fieldKeys.pageNo]: 1,
        [fieldKeys.count]: 10
    };
    const [fieldValues, setFieldValues] = useState(defaultFieldValues)

    const setValue = (key, value) => {
        setFieldValues((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const handleSearch = async (page, size) => {
        getList(fieldValues, toast, setData, setIsLoading, page, size);
    }
    const handleReset = () => {
        setFieldValues(defaultFieldValues);
        setData(null)
    }

    const submitBulkReSurvey = async (notifyPayload) => {
        let refilteredData = selectedData
            .map((data) => ({
                claimIntimationNumber: data.claimNo,
                fieldSurveyNumber: data.surveyNumber,
            }));
        notifyPayload.claims = refilteredData;

        setIsLoading(true);
        try {
            await submitBulkSurveyAction(
                notifyPayload,
                roleDataCookie,
                refilteredData,
                true,
            );
            setSelectedData([])
            handleSearch()
            setIsLoading(false);
            setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})

        } catch (error) {
            console.error('Error in submitBulkReSurvey:', error);
            setIsLoading(false);
            setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})
        }
    };

    const handlePageOrSizeChange = (page, count) => {
        if(String(page)) {
            setValue(fieldKeys.pageNo, page)
        }
        if(String(count)) {
            setValue(fieldKeys.count, count)
        }
        handleSearch(page,count)
    }

    useEffect(()=> {
        setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})
        
    },[])

    return (
        <section className="p-4">
            <h1 className="headerclaim">Survey Management</h1>
            <hr />
            <Filters setValue={setValue} fieldValues={fieldValues} productNames={productNames} handleSearch={handleSearch} handleReset={handleReset} setData={setData}/>
            <div className="mt-1">
                    <>
                        {data?.list?.length ? (
                            <Row>
                                <Col xs={11}>
                                    <h2 className="heading_h2">
                                        Search Results ({data?.totalRecords})
                                    </h2>
                                </Col>
                                <>
                                    <Col xs={1}>
                                        <FieldSurveyRequest
                                            notifyPayload={notifyResurveyPayload}
                                            setNotifyPayload={setNotifyResurveyPayload}
                                            isBulkReSurveyRequest={true}
                                            submitBulkReSurvey={submitBulkReSurvey}
                                            bulkReSurveyLoading={isLoading}
                                            setBulkReSurveyLoading={setIsLoading}
                                            disableRequest={!selectedData?.length}
                                            claimDetailCookie={{}}
                                            // surveyorName={fieldResurveyData[0].surveyor}
                                            requestButtonText={'Reassign'}
                                            hideVendorName= {roleDataCookie?.roleName === VENDOR_MANAGER}
                                            vendorId ={roleDataCookie?.roleName === VENDOR_MANAGER ?vendorManagerDetails?.vendorId: undefined}
                                        />
                                    </Col>
                                </>
                            </Row>
                        ): ''}

                        <DataTable data={data?.list} selectedData={selectedData} setSelectedData={setSelectedData} totalRecordsCount={data?.totalRecords} handlePageOrSizeChange={handlePageOrSizeChange} getList={handleSearch} setIsLoading={setIsLoading}/>
                    </>
            </div>
            {isLoading && (<LoadingPage  kshemaLoader/>)}
        </section>
    )
}

export default ListPage;